module.exports = __webpack_public_path__ + "static/media/square.d4d69ca3.svg";